import { createContext, useCallback, useContext, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { T } from "../i18n/translations";
import { langFromPath, pageKeyFromPath, pathFor } from "../lib/site";

const LangCtx = createContext(null);

export const LangProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = langFromPath(location.pathname);
  const pageKey = pageKeyFromPath(location.pathname);

  const toggle = useCallback(() => {
    const next = lang === "pt" ? "en" : "pt";
    localStorage.setItem("mjn_lang", next);
    navigate(pathFor(pageKey, next));
  }, [lang, pageKey, navigate]);

  const value = useMemo(() => ({
    lang,
    other: lang === "pt" ? "en" : "pt",
    t: T[lang],
    toggle,
    pageKey,
    path: (k) => pathFor(k, lang),
  }), [lang, pageKey, toggle]);

  return <LangCtx.Provider value={value}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
